export const topicChipTone = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-300",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
} as const;

export const topicIconTone = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-500 text-background-50",
} as const;

export const topicBarTone = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
} as const;

export const getTopicTone = (slug: string): "primary" | "accent" | "secondary" => {
  const map: Record<string, "primary" | "accent" | "secondary"> = {
    "yule-shijian": "primary",
    "yingshi-xuanfa": "accent",
    "zongyi-muhou": "secondary",
    "daiyan-fengbo": "primary",
    "yinyue-xianchang": "secondary",
    "wangluo-redian": "accent",
  };
  return map[slug] ?? "primary";
};